module.exports = __webpack_public_path__ + "media/images/emblems/Crans-pres-Celigny-coat_of_arms-0e3172a24df4b46104884fb164f8ffe6.svg";